var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.modal)?_c('RoomSelector',{attrs:{"list-open-conversations":"","show-postable-only":"","dialog-title":_vm.dialogTitle},on:{"close":_vm.closeModal,"select":_vm.openConversation}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }